/**
 * Normalize file pre-check stats for frontend combined-limit checks.
 *
 * Page/slide limits only apply to image-based documents. Text-extractable PDFs
 * and PPTs are governed by content length, regardless of page/slide count.
 */
export const isImageBasedFile = (fileInfo = {}) =>
  fileInfo.is_image_based === true || fileInfo.isImageBased === true;

export const getLimitPageCount = (fileInfo = {}) =>
  isImageBasedFile(fileInfo) ? (fileInfo.page_count ?? fileInfo.pageCount ?? 0) : 0;

export const getLimitSlideCount = (fileInfo = {}) =>
  isImageBasedFile(fileInfo) ? (fileInfo.slide_count ?? fileInfo.slideCount ?? 0) : 0;

export const getContentLength = (fileInfo = {}) =>
  fileInfo.content_length ?? fileInfo.contentLength ?? 0;

export const summarizeFileStats = (files = []) => ({
  pageCount: files.reduce((sum, file) => sum + getLimitPageCount(file), 0),
  slideCount: files.reduce((sum, file) => sum + getLimitSlideCount(file), 0),
  contentLength: files.reduce((sum, file) => sum + getContentLength(file), 0),
});

export const normalizePreCheckStats = (filesInfo = []) =>
  filesInfo.map((fileInfo) => ({
    pageCount: getLimitPageCount(fileInfo),
    slideCount: getLimitSlideCount(fileInfo),
    contentLength: getContentLength(fileInfo),
    isImageBased: isImageBasedFile(fileInfo),
  }));

/**
 * 채팅 첨부 글자 수 합산 검사. currentStats·newStats 는 쪽 단위로 정리되지 않는 파일만 합한 값이다.
 * 새 파일만으로 넘었고 서버가 파일별로 이미 알렸다면 합산 문구를 따로 만들지 않는다.
 */
export const checkChatCombinedLimit = ({
  currentStats,
  newStats,
  maxContentLength,
  filesInfo = [],
}) => {
  const current = currentStats?.contentLength || 0;
  const added = newStats?.contentLength || 0;
  const total = current + added;
  if (total <= maxContentLength) {
    return { exceededLimits: [], combinedWarning: null };
  }

  const exceededLimits = [
    `총 분석량: 현재 ${current.toLocaleString()}자 + 새 파일 ${added.toLocaleString()}자 = 총 ${total.toLocaleString()}자 (최대 ${maxContentLength.toLocaleString()}자)`,
  ];
  const hasFileIssue = (filesInfo || []).some((f) => f?.issues?.length > 0);
  let combinedWarning = null;
  if (current > 0) {
    combinedWarning = '이미 첨부한 파일과 합치면 한도를 넘어요. 넘는 부분은 분석에서 빠져요.';
  } else if (!hasFileIssue) {
    combinedWarning = '올린 파일을 합치면 한도를 넘어요. 넘는 부분은 분석에서 빠져요.';
  }
  return { exceededLimits, combinedWarning };
};
